import * as estates from './estates';
import * as investOffer from './invest-offer';
import * as shares from './shares';

export default {
    estates,
    investOffer,
    shares,
};
